import React, { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { Routes, Route } from "react-router-dom"
import "../../css/scss/custom.scss"
import "../../css/theme/custom.css"
import "../../css/bootstrap-float-label.min.css"
import { registerAnalyticsPageView } from "../../Code/Utilities"
import UserRedemptionPage from "../../Components/UserRedemptionPage"
import RouteErrorBoundary from "../../Components/Common/RouteErrorBoundary"
import { useUserData } from "../../Context/user"
import { useAppData } from "../../Context/appData"
import PrerenderManager from "../../Code/PrerenderManager"
import Main from "./Main"

export default function App() {
  const location = useLocation()
  const { loggedInUser } = useUserData()
  const { fullCharityList, loading } = useAppData()

  useEffect(() => {
    const registerPageView = () => {
      const options = {
        page_title: document.title,
        page_location: window.location.href,
        page_path: location?.pathname,
        user_id: !!loggedInUser ? loggedInUser.UserId : undefined,
      }
      registerAnalyticsPageView(options)
      import.meta.env.MODE === "development" && console.log("Registered gtag page view: ", options)
    }
    registerPageView()

    import.meta.env.MODE === "development" && console.log(`Charity list contains ${fullCharityList?.length} charities`)
  }, [location, loggedInUser, fullCharityList])

  // Load initial data useEffect
  useEffect(() => {
    // Declare that this app needs to wait for app data to load
    PrerenderManager.requireOperation('appData');

    async function loadData() {
      // Data loading will happen in the context provider
      // Once complete, we signal ready
    }
    loadData();
  }, []);

  // Signal PrerenderManager when app data is loaded
  useEffect(() => {
    if (!loading) {
      PrerenderManager.markReady('appData');
    }
  }, [loading]);

  return (
    <RouteErrorBoundary resetKey={`${location.pathname}${location.search}`}>
      <Routes>
        {/*As these don't show a Header etc, they don't use Main*/}
        <Route path="/Redeem/Custom/:UserId" element={<UserRedemptionPage />} />
        <Route path="/Redeem/Custom/" element={<UserRedemptionPage />} />
        <Route path="*" element={<Main />} />
      </Routes>
    </RouteErrorBoundary>
  )
}
